import { apiCall } from './api';
import { ACADEMY, ACADEMY_DETAILS, ACADEMY_STATUS, ACADEMY_STATS } from '../config/api';

// Get all Academy items
export const getAcademy = async (params = {}) => {
  try {
    console.log('🚀 getAcademy called with params:', params);
    console.log('🔗 Making API call to:', ACADEMY);
    
    const response = await apiCall(ACADEMY, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getAcademy:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getAcademy:', error);
    throw error;
  }
};

// Get Academy item by ID
// Expected API endpoint: GET /api/academy/{id}
// Expected response structure:
// {
//   "success": true,
//   "data": {
//     "id": 1,
//     "title": "HTML formatted title",
//     "description": "HTML formatted description", 
//     "status": "active|inactive|pending",
//     "certificate_number": "CERT-001",
//     "video_url": "HTML formatted video content or URL",
//     "created_at": "2024-01-01T00:00:00Z",
//     "updated_at": "2024-01-01T00:00:00Z",
//     "meta": {
//       "tags": ["tag1", "tag2"],
//       "category": "certification",
//       "duration": "2 hours",
//       "difficulty": "intermediate"
//     }
//   }
// }
export const getAcademyById = async (academyId) => {
  try {
    const endpoint = ACADEMY_DETAILS.replace('{id}', academyId);
    console.log('🔍 Fetching academy details from:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    
    console.log('📡 API Response from getAcademyById:', response);
    return response;
  } catch (error) {
    console.error('❌ Error fetching Academy item:', error);
    throw error;
  }
};

// Create new Academy item
export const createAcademy = async (academyData) => {
  try {
    console.log('🚀 createAcademy called with data:', academyData);
    console.log('🔗 Making API call to:', ACADEMY);
    
    const response = await apiCall(ACADEMY, {
      method: 'POST',
      data: academyData
    });
    
    console.log('📡 API Response from createAcademy:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating Academy item:', error);
    throw error;
  }
};

// Update Academy item
export const updateAcademy = async (academyId, academyData) => {
  try {
    const endpoint = ACADEMY_DETAILS.replace('{id}', academyId);
    console.log('🚀 updateAcademy called with ID:', academyId, 'and data:', academyData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: academyData
    });
    
    console.log('📡 API Response from updateAcademy:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating Academy item:', error);
    throw error;
  }
};

// Delete Academy item
export const deleteAcademy = async (academyId) => {
  try {
    const endpoint = ACADEMY_DETAILS.replace('{id}', academyId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting Academy item:', error);
    throw error;
  }
};

// Update Academy status
export const updateAcademyStatus = async (academyId, status) => {
  try {
    const endpoint = ACADEMY_STATUS.replace('{id}', academyId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating Academy status:', error);
    throw error;
  }
};

// Get Academy statistics
export const getAcademyStats = async () => {
  try {
    const response = await apiCall(ACADEMY_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Academy stats:', error);
    throw error;
  }
};
